module.exports = __webpack_public_path__ + "static/bg-all-abilities-87dbe27d7685d4b61854bd4994932a22.jpeg";